import { log2 } from "./log2";
import { sendCommandToParentWindow } from "./parentWindowConnection";
import _ from "lodash";
import { getPersistenceData, setPersistenceData } from "./persistenceStorage";

const log = log2("TriggerWorker");

let singleton = null;

export class Trigger {
    constructor(triggers, lang, offlineMode) {
        log.info("constructor", triggers, lang);
        this.days = {
            sunday: 0,
            monday: 1,
            tuesday: 2,
            wednesday: 3,
            thursday: 4,
            friday: 5,
            saturday: 6,
        };
        this.operators = {
            equal: (a, b) => a === b,
            not_equal: (a, b) => a !== b,
            less_than: (a, b) => a < b,
            greater_than: (a, b) => a > b,
            less_than_or_equal: (a, b) => a <= b,
            greater_than_or_equal: (a, b) => a >= b,
            contains: (a, b) => a.includes(b),
            not_contains: (a, b) => !a.includes(b),
        };
        this.triggered = {};
        this.triggers = triggers;
        this.offlineMode = offlineMode;
        this.lang = lang || "tr";
        this.tick = parseInt(getPersistenceData("supsis-tick")) || -1;
        this.pageTick = -1;
        this.title = "";
        this.pageUrl = "";

        //workaround for iframe connecting to parent window
        setTimeout(() => {
            sendCommandToParentWindow("createTrigger", null);
            this.start();
            this.task = setInterval(this.start.bind(this), 1000 * 10);
        }, 3000);

        singleton = this;
    }

    static create(triggers, lang, offlineMode) {
        return singleton || new Trigger(triggers, lang, offlineMode);
    }

    static setLang(lang) {
        if (!!singleton) {
            singleton.lang = lang;
        }
    }

    static setOfflineMode(mode) {
        if (!!singleton) {
            singleton.offlineMode = mode;
        }
    }

    static setURL(url) {
        if (!!singleton) {
            singleton.pageUrl = url;
        }
    }

    static setTitle(title) {
        if (!!singleton) {
            singleton.title = title;
        }
    }

    start() {
        this.pageTick++;
        this.tick++;
        setPersistenceData("supsis-tick", this.tick);
        this.day = new Date().getDay();
        this.time = new Date().getHours();
        log.info("start", this);
        let filteredTriggers = this.triggers.filter((trigger) => !Object.keys(this.triggered).includes(trigger._id));
        for (const trigger of _.sortBy(filteredTriggers, (x) => x.order)) {
            if (this.isMatch(trigger.conditions)) {
                this.execute(trigger).catch(console.error);
                break;
            }
        }
    }

    isMatch(conditions) {
        log.info("isMatch", conditions);
        let isPassed = true;
        conditions.forEach(({ condition, value, operator }) => {
            let localPass = true;
            switch (condition) {
                case "dayTime":
                    localPass = this.operators[operator](this.time, parseInt(value));
                    break;
                case "weekDay":
                    localPass = this.operators[operator](this.day, this.days[value]);
                    break;
                case "spendTimePage":
                    localPass = this.operators[operator](this.pageTick * 10, parseInt(value));
                    break;
                case "spendTimeSite":
                    localPass = this.operators[operator](this.tick * 10, parseInt(value));
                    break;
                case "pageUrl":
                    localPass = this.operators[operator](this.pageUrl, value);
                    break;
                case "pageTitle":
                    localPass = this.operators[operator](this.title, value);
                    break;
                case "systemStatus":
                    log.info("systemStatus", typeof value, value, this.offlineMode, operator);
                    localPass = this.operators[operator](!this.offlineMode, value === "true");
                    break;
                case "visitorName":
                    break;
                case "department":
                    break;
            }
            isPassed = isPassed && localPass;
        });
        return isPassed;
    }

    /**
     * @param trigger {{siteId:string,title:string,firstAnswer:string,secondAnswer:string,messageDuration:number,enabled:boolean,message:[{code:string,content:string}],confirmAskingDialog:[{code:string,content:string}],dismissAskingDialog:[{code:string,content:string}] ,options:[] }}
     */
    async execute(trigger) {
        log.info("execute trigger", {
            trigger,
            lang: this.lang,
        });
        this.triggered[trigger.id] = true;

        const navigatorLanguage = navigator.language.split("-")[0];

        const messages = _.get(trigger, "message", []) || [];

        const langMatchedMessage = messages.find((l) => l.code === this.lang);
        const navigatorLangMatchedMessage = messages.find((l) => l.code === navigatorLanguage);

        const fallbackMessage = _.get(langMatchedMessage, "content", _.get(_.head(messages), "content"));

        const msgHTML = this.lang
            ? _.get(langMatchedMessage, "content", fallbackMessage)
            : _.get(navigatorLangMatchedMessage, "content", fallbackMessage);

        //  calculate yes button text
        const confirmAskingDialog = Array.isArray(trigger.confirmAskingDialog) ? trigger.confirmAskingDialog : [];
        const validConfirmMessages = confirmAskingDialog.filter((l) => l.code === this.lang);
        const firstConfirmMessage = _.head(validConfirmMessages);
        const first = _.get(firstConfirmMessage, "content", trigger.firstAnswer);


        //  calculate no button text
        const dismissAskingDialog = Array.isArray(trigger.dismissAskingDialog) ? trigger.dismissAskingDialog : [];
        const validDismissMessages = dismissAskingDialog.filter((l) => l.code === this.lang);
        const firstDismissMessage = _.head(validDismissMessages);
        const second = _.get(firstDismissMessage, "content", trigger.secondAnswer);



        let duration = parseInt(trigger.messageDuration);
        let enabled = trigger.enabled;

        const answers = { first, second, visitorLanguageSelectionFromCpanel: this.lang };
        const title = trigger.title;
        sendCommandToParentWindow("execTrigger", [title, msgHTML, duration, trigger.options, enabled, answers, {showHeaderImage: trigger.showHeaderImage}, {popupTireggers: trigger.popupTireggers}]);
    }

    static pause() {
        log.info("paused");
        if (!!singleton) {
            clearInterval(singleton.task);
        }
    }

    static resume() {
        log.info("resumed");
        if (!!singleton) {
            singleton.task = setInterval(singleton.start.bind(singleton), 1000 * 10);
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/trigger.js